import type { FillPattern } from "@msuite/utils/schemas";
import { CheckerPattern } from "./checker-pattern";
import { CrossHatchPattern } from "./cross-hatch-pattern";
import { DotsPattern } from "./dots-pattern";
import { GridPattern } from "./grid-pattern";
import { HatchPattern } from "./hatch-pattern";
import { PlusPattern } from "./plus-pattern";
import type { PatternProps } from "./shared";
import { SolidPattern } from "./solid-pattern";
import { StripesPattern } from "./stripes-pattern";
import { WavesPattern } from "./waves-pattern";

export function Pattern({
	color,
	type,
	salt,
}: PatternProps & {
	type: FillPattern;
}) {
	switch (type) {
		case "hatch":
			return (
				<HatchPattern
					color={color}
					salt={salt}
				/>
			);
		case "crosshatch":
			return (
				<CrossHatchPattern
					color={color}
					salt={salt}
				/>
			);
		case "solid":
			return (
				<SolidPattern
					color={color}
					salt={salt}
				/>
			);
		case "dots":
			return (
				<DotsPattern
					color={color}
					salt={salt}
				/>
			);
		case "grid":
			return (
				<GridPattern
					color={color}
					salt={salt}
				/>
			);
		case "stripes":
			return (
				<StripesPattern
					color={color}
					salt={salt}
				/>
			);
		case "checker":
			return (
				<CheckerPattern
					color={color}
					salt={salt}
				/>
			);
		case "waves":
			return (
				<WavesPattern
					color={color}
					salt={salt}
				/>
			);
		case "plus":
			return (
				<PlusPattern
					color={color}
					salt={salt}
				/>
			);
		case "none":
			return null;
		default:
			return null;
	}
}
